module.exports = __webpack_public_path__ + "static/media/desktop_separator_02.7d361b0c.webp";